import { BsArrowDown } from "react-icons/bs";
import styled from "styled-components";
import cocktailImage from "../../assets/images_1/8_Cocktail/8_Landing-Background.png";
import procedureBack from "../../assets/images_1/8_Cocktail/8_Recipe_Background.png";
import gingerbells from "../../assets/images_1/8_Cocktail/8_Ginger-Bells.png"
import theme from "../../modules/themes";

export const Wrapper = styled.section`
  min-height: ${window.innerHeight}px;
  line-height:1.5;
  color:#5D3D31;
  background-color:white;
`;

export const ImageWrapper = styled.section`
  height: ${window.innerHeight}px;
  background-image: url(${cocktailImage});
  background-size: cover;
  background-position: center;
  background-color:black;
  background-repeat:no-repeat;
  position: relative;
`;

export const Container = styled.div`
  width: 75%;
  margin: auto;
`;

export const Title = styled.h1`
  font-size: 32px;
  color: #ffe4cb;
  padding-top: 45px;
  // width: 75%;
  margin: auto;
  font-family: walbaumBook-medium;

  @media(max-width:450px){
    font-size: 22px;
    padding-top:35px
  }
`;
export const Horizontal = styled.div`
  width: 50px;
  height: 1px;
  background-color: ${theme.primaryYellow};
  margin-top: 10px;
  @media(max-width:430px){
    width: 35px;
    margin-top: 8px;
  }
`;

export const CarouselContainer = styled.div`
  width: 100%;
  margin: auto;
  margin-top:20vh
`

export const ScrollIndicatorSection = styled.section`
  position: absolute;
  width: 100%;
  bottom: 10px;
  left: 0;
  text-align: center;
  color: #d87a3e;
`;

export const ScrollIndicatorText = styled.p`
  text-transform: uppercase;
  font-size: 10px;
`;

export const ScrollIndicatorIcon = styled(BsArrowDown)`
  margin-top: 2%;
`;

export const ProcedureSection = styled.section`
  position:relative;
  min-height:${window.innerHeight}px;
  background-image: url(${procedureBack});
  background-size: 100% 100%;
  background-position: center;
  text-align:center;
  color: ${theme.primaryWhite};
  // font-size: calc(16px + (26 - 14) * ((100vw - 320px) / (1920 - 320)));
  
  h2{
    font-size:24px;
    padding:36px 0 20px 0;
    color:${theme.primaryYellow};
    font-family: walbaumBook-medium;
  }
  .h3{
    font-size:18px;
    text-align:left;
    color:${theme.primaryYellow};
    margin:25px 0 5px 0;
    text-transform:uppercase;
    font-family: walbaumBook-medium;
  }
  ol{
    list-style:none;
    text-align:left;
    padding:0;
  }
  ol .last{
    margin-top:20px
  }
  .procedure li{
    margin-bottom:20px
  }
  .hr-container{
    margin 10.6px 0 20.5px 0;
    display:flex;
    flex-direction:column;
    align-items:center
  }
  button{
    padding:15px 20px;
    border:0px solid #d87a3e;
    color:${theme.primaryWhite};
    font-weight:bold;
    outline:0;
    box-shadow:0;
    background-color:${theme.primaryBlue};
    margin:20px 0 70px 0;
    font-family: walbaumBook-medium;
  }
  .hr{
    width: 31%;
    border: 0.5px solid ${theme.primaryYellow};
    margin: 10px 0 0 0;
  }
  .method-para{
    text-align:left;
    margin-bottom:25px
  }
  @media(min-height:480px){
    font-size:15px;
  }
  @media(max-width:430px){
    h2{
      font-size:22px;
      padding:36px 0 13px 0;
    }
    .h3{
      font-size:17px;
    }
    .hr{
      margin: 8px 0 0 0;
      border:0;
      height:1px;
      background-color:#d87a3e
    }
  }
`

export const SecondaryImage = styled.section`
  position:relative;
  min-height:${window.innerHeight-20}px;
  background-image: url(${gingerbells});
  background-size: cover;
  background-position: center;
`

export const ImagesContainer = styled.section`
  position:relative
`

export const CocktailBanditSection = styled.section`
  min-height:${200}px;
  width:90%;
  margin:auto;
  position:relative;
  background-color:white;
  text-align:left;
  img{
    margin-top:15px
  }
  .h2{
    font-size:18px;
    margin-top:25px;
    color:#D87A3E;
    font-family: walbaumBook-medium;
  } 
  p{
    margin:20px 0;
    color:#5D3D31;
  }
  .buttons-container{
    display:flex;
    flex-direction:column;
    align-items:center
  }
  button{
    padding:14px 7px;
    border:0px solid #d87a3e;
    color:${theme.primaryWhite};
    font-weight:600;
    outline:0;
    box-shadow:0;
    width:184px;
    background-color:${theme.primaryBlue};
    margin: 15px 0 45px 0;
    font-family: walbaumBook-medium;
  }
  @media(min-height:480px){
    font-size:15px;
  }
  @media(max-width:430px){
    button{
      margin: 10px 0 45px 0;
    }
  }
  @media(max-width:400px){
    button{
      padding:12px 3px;
      border:1px solid #d87a3e;
      width:184px;
      font-size:12px
    }
    button:nth-child(3){
      margin:25px 0 50px 0;
    }
  }
`
export const Footer = styled.footer`
  // height:220px;
  padding-bottom:20px;
  background-color:${theme.primaryBlue};
  background-size:cover;
  background-position:center;
  text-align:center;
  color:${theme.primaryWhite};
  line-height: 1.6;
  .container{
    width:90%;
    margin:auto
  }
  img{
    width:80px;
    margin:10px 0 5px 0
  }
  .h5{
    font-size: 11.5px;
    font-family: walbaumBook-medium;
    padding-top:0px;
    color:${theme.primaryWhite};
    line-height: 1.8;
  }
  p{
    font-size: 9.5px;
    line-height: 1.8;
  }
  a{
    color${theme.primaryWhite};
    font-size: 10px;
    line-height: 1.8;
  }
  a{
    color: ${theme.primaryWhite}
  }
  .footer-links-section-container{
    width:100%;
    margin:auto;
  }
  .footer-links-section{
    display:flex;
    justify-content:center;
  }
  .footer-links-section a{
    margin-left:5px;
    margin-right:5px;
  }
  .footer-links-section:nth-child(1){
    margin-top:20px
  }
  @media(max-width:430px){
    // height:200px;
    .container{
      width:95%;
    }
    .footer-links-section{
      justify-content:center;
    }
    p, a{
      font-size: 8px;
    } 
  }
  @media(max-width:400px){
    p, a{
      font-size: 8px;
    } 
  }
  @media(max-width:350px){
    img{
      width:70px;
      margin:10px 0 0px 0
    }
    .h5{
      font-size: 10.5px;
      line-height:1.9
    }
    p, a{
      font-size: 6.5px;
      line-height:1.9
    } 
  }
`